import { Link } from 'react-router-dom'
import { PowerOff } from 'lucide-react'
import { Button, Card, EmptyState } from '@/components/ui'
import { MODULE_LABEL } from '@/lib/modules'
import { useT } from '@/i18n/I18nProvider'
import type { ModuleName } from '@/types/api'

/**
 * Where a page would be, for a part of the application this company does not
 * have.
 *
 * Reached by a link from before the module was switched off, a bookmark, a
 * scanned sticker, or a request the server refused mid-session. It says what
 * is off and that nothing is broken — the worker who sees this did nothing
 * wrong, and their data is still there for the day it is switched back on —
 * and offers the one way out that always works.
 */
export function ModuleDisabled({ module }: { module: ModuleName }) {
  const t = useT()

  return (
    <Card>
      <EmptyState
        icon={<PowerOff className="size-8" aria-hidden />}
        title={t('module.disabled.title')}
        description={t('module.disabled.description', { module: t(MODULE_LABEL[module]) })}
        action={
          <Button variant="secondary" nativeButton={false} render={<Link to="/" />}>
            {t('module.disabled.home')}
          </Button>
        }
      />
    </Card>
  )
}
